import {Component, ViewChild, ElementRef, OnInit, Renderer2, Input, AfterViewInit} from '@angular/core';

import { BaseComponent } from 'sharedFeatures/base';

@Component({
    selector: 'basepane',
    templateUrl: './base-pane.component.html',
    styleUrls: ['./base-pane.component.less']
})
export class BasePaneComponent extends BaseComponent implements AfterViewInit{

    title: string = $localize`TITLE`;

    @Input()
    height: number | undefined = undefined;

    @Input() 
    width: number | undefined = undefined;

    @Input()
    margin: string = "";

    @Input()
    borderTopRadius: number = 9;

    @Input()
    borderBottomRadius: number = 9;

    contentComponent: any;

    @ViewChild('pane')
    pane: ElementRef | undefined = undefined;

    testId: string = '';

    constructor(el: ElementRef, renderer: Renderer2) {

        super(el, renderer);

    }

    ngAfterViewInit() {
        this.init();
    }
    
    init(): void{
        if (!this.pane) return;

        if (this.width) {
            this.r.setStyle(this.pane.nativeElement, "width", this.width + 'px');
        }
        if (this.height) {
            this.r.setStyle(this.pane.nativeElement, "height", this.height + 'px');
        }

        if (this.margin) {
            this.r.setStyle(this.pane.nativeElement, "margin", this.margin + 'px');
        }

        if (this.testId) this.r.setAttribute(this.pane.nativeElement, "data-testid", this.testId);

        this.r.setStyle(this.pane.nativeElement, 'border-top-left-radius', this.borderTopRadius + 'px');
        this.r.setStyle(this.pane.nativeElement, 'border-top-right-radius', this.borderTopRadius + 'px');

        this.r.setStyle(this.pane.nativeElement, 'border-bottom-left-radius', this.borderBottomRadius + 'px');
        this.r.setStyle(this.pane.nativeElement, 'border-bottom-right-radius', this.borderBottomRadius + 'px');
    }

    public setZIndex(zIndex: number): void {

        this.r.setStyle(this.getElDom(), 'zIndex', zIndex);

    }

}